export default __webpack_public_path__ + "static/media/wood_black.6c2a7d56.jpg";